export const HEADER = [
  "loan_id",
  "price",
  "deposit",
  "tp_deposit",
  "rate",
  "term",
  "customer_name",
  "customer_email",
  "job_title",
  "tradesperson_name",
  "fee_1",
  "fee_2",
  "amount_to_pay",
  "status",
  "date_updated",
  "tradesperson_email",
  "bank_account_name",
  "bank_account_number",
  "sort_code",
  "loan_date_created",
  "legacy_rate",
];
